import { render, staticRenderFns } from "./participant-index.vue?vue&type=template&id=13f3c4c0&"
import script from "./participant-index.vue?vue&type=script&lang=ts&"
export * from "./participant-index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports